const SimpleModal = ({ title, content, isModalOpen, setIsModalOpen, canClose = true }) => {
    return (
        <div className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ${isModalOpen ? "" : "hidden"}`}>
            <div className={"bg-white rounded-lg p-6 max-w-md w-full"}>
                <div className={"flex justify-between items-center mb-4"}>
                    <h3 className="text-xl font-bold text-gray-800">{ title }</h3>
                    {
                        canClose && (
                            <button className="text-gray-500 hover:text-gray-700" onClick={() => setIsModalOpen(false)}>
                                <i className="fas fa-times"></i>
                            </button>
                        )
                    }
                </div>

                {
                    content
                }
            </div>
        </div>
    );
}

export default SimpleModal;